import React from 'react';
import { useDispatch } from 'react-redux';
import Typo from 'components/ui/typo';
import Button from 'components/ui/button';
import Trends from 'components/ui/trends';

const TableBody = ({
  tableData = [],
  activeDropDown,
  matchStatus,
  selfUser,
  lbObj,
  legSettingPage,
  tableBtnFunc,
  onRowClick,
  handleOtherUserTeamOverlay,
  tableConfig
}) => {
  const dispatch = useDispatch();

  // Hardcoded table configuration

  const selfTeamIndex = tableData?.findIndex((data) => data?.TeamID === selfUser?.[0].temid);

  function getRowData(type, tableBody, data) {
    switch (type) {
      case 'rank':
        const mal = data[tableBody.keys[0]];
        return mal || '-';
      case 'achievements':
        const nal = data[tableBody.keys[0]];
        if (data?.lateOnboard == 1) {
          return <><div className='si-lateonBoardInfo'>
            <i className='lms-lateonboard'></i>
          </div>
            {nal || '-'}
          </>
        } else {
          return nal || '-'
        }
      case 'text':
        let val = data[tableBody.keys[0]] || data[tableBody.keys[1]];
        if (val?.length > 30 && tableBody.keys[0] === 'TeamName') {
          val = `${val.substring(0, 30)}...`;
        }
        return val || '-';
      case 'trendWithText':
        let trend = data[tableBody.keys[0]];
        let rank = data[tableBody.keys[1]]
        if(trend !==  null || trend !== undefined){
          return <Trends icon={trend} text={rank} />;
        }else{
          return rank || '-';
        }
        
      default:
        return '-';
    }
  }

  return (
    <div className='si-tbl__body'>
      {tableData?.map((data, index) => {
        const isSelfRow = index === selfTeamIndex;
        return (
          <div
            key={index}
            className={`si-tbl__row ${isSelfRow ? 'si-self' : ''}`}
            onClick={() => {
              if (!isSelfRow) {
                onRowClick(data?.TeamID, data?.SocialID, (data?.lateOnboard ?? 0), data?.TeamName)
                handleOtherUserTeamOverlay(true)
              }
            }}
          >
            {tableConfig?.map((tableBody, tableBodyIndex) => (
              <div key={tableBodyIndex} className={`si-tbl__cell si-tbl__cell--${tableBody?.cls}`}>
                {getRowData(tableBody?.type, tableBody, data)}
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default TableBody;
